/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { UomDetailsDto } from './uom-details.dto';
import { UoMDimension } from './uom-list-item.dto';

export const UomDetailsMapper = entity<UomDetailsDto>({
  dimension1: enumeration(UoMDimension),
  dimension2: enumeration(UoMDimension),
  dimension3: enumeration(UoMDimension),
});
